import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["optionsField", "unitField", "fastingField", "fastingHours"]

  connect() {
    this.toggle()
  }

  kindChanged(event) {
    this.toggle(event.target.value)
  }

  toggle(kind) {
    const selectedKind = kind || this.currentKind()
    this.toggleField(this.optionsFieldTarget, selectedKind === "choice" || selectedKind === "composite")
    this.toggleField(this.unitFieldTarget, selectedKind === "number")
    this.toggleField(this.fastingFieldTarget, selectedKind === "fasting")
  }

  currentKind() {
    const checked = this.element.querySelector("input[name='habit[kind]']:checked")
    return checked ? checked.value : null
  }

  toggleField(element, show) {
    if (!element) return
    element.classList.toggle("hidden", !show)
  }

  applyPreset(event) {
    if (!this.hasFastingHoursTarget) return
    const hours = event.currentTarget.dataset.hours
    if (!hours) return
    this.fastingHoursTarget.value = hours
  }
}
